import React, { useCallback, useEffect } from 'react'
import { ApolloClient } from '@apollo/client'
import { useLazyQuery } from '@apollo/client/react'
import { FloatingCallToActionImage } from '@/molecules/FloatingCallToAction/FloatingCallToActionImage'
import { GET_FLOATING_CALL_TO_ACTION_QUERY } from '@/services/CmsService/CallToAction'
import { GuildPermissions } from '@/services/GuildUserService'
import { GetFloatingCallToActionQuery } from '@/types/codegen-contentful'
import { useSafeAnalytics } from '@/utils/analytics'
import { FloatingCallToActionDisplay } from './FloatingCallToActionDisplay'

interface FloatingCallToActionProps {
  client: ApolloClient
  locale: string
  preview: boolean
  isGuildMember: boolean
  guildPermissions?: GuildPermissions
}

export const FloatingCallToAction: React.FC<FloatingCallToActionProps> = ({
  client,
  locale,
  preview,
  isGuildMember,
  guildPermissions,
}) => {
  const { track } = useSafeAnalytics()
  const [getFloatingCta, { data, loading }] = useLazyQuery<GetFloatingCallToActionQuery>(
    GET_FLOATING_CALL_TO_ACTION_QUERY,
    {
      client,
      errorPolicy: 'all',
    },
  )

  const handleClick = useCallback(() => {
    track('On Tap', {
      element_name: 'cta_tickets_floating',
      value: data?.callToActionCollection?.items?.[0],
    })
  }, [data, track])

  useEffect(() => {
    if (locale) {
      getFloatingCta({
        variables: {
          locale,
          preview,
        },
      })
    }
  }, [getFloatingCta, locale, preview])

  const firstCTA = data?.callToActionCollection?.items?.[0]
  if (loading || !firstCTA) return null

  return (
    <div>
      <div className="hidden sm:block">
        <FloatingCallToActionImage
          floatingCta={firstCTA}
          onClick={handleClick}
          isGuildMember={isGuildMember}
          guildPermissions={guildPermissions}
        />
      </div>
      <div className="block w-full sm:hidden">
        <FloatingCallToActionDisplay
          floatingCta={firstCTA}
          onClick={handleClick}
          isGuildMember={isGuildMember}
          guildPermissions={guildPermissions}
        />
      </div>
    </div>
  )
}
